import { Button } from '@ixyberfree/ixybercomponents';
import { CloseIcon } from 'Assets/icons';
import * as hmiclientbase from 'components/hmilib/hmiclientbase';
import React from 'react';
import { Select } from 'styles';

interface IPropsEventElement {
    eventIdObject: any;
    closeCB?: Function;
}

export const EventElement: React.FC<IPropsEventElement> = (props) => {
    let { eventIdObject, closeCB } = props;

    let [eventObject, setEventObject] = React.useState<any>();

    let [pathsRef, setPathsRef] = React.useState<string[]>([]);

    React.useEffect(() => {
        let type = 'iXyberBaseLib.Scripts.PyScript';
        if (type != null && type != '') {
            hmiclientbase.SettingsGetPathsType(type).then((dataPathsRef: any) => {
                if (dataPathsRef != null) setPathsRef(dataPathsRef);
            });
        }

        UpdateEventObject();
    }, []);

    const UpdateEventObject = () => {
        hmiclientbase.SettingsGetObjectDto(eventIdObject).then((data: any) => {
            data.RefObjects = data.RefObjects.sort((a: any, b: any) => (a.name > b.name ? 1 : -1));
            setEventObject(data);
        });
    };

    const AddRefObject = async (rpath: string) => {
        let numfunc = 1;

        for (let numfunci = 1; numfunci < 999999; numfunci++) {
            for (let ref in eventObject.RefObjects) {
                if (eventObject.RefObjects[ref].name == 'FUNCTION' + numfunci) {
                    numfunc = numfunci;
                    break;
                }
            }

            if (numfunc != numfunci) {
                numfunc = numfunci;
                break;
            }
        }

        let nameRef = 'FUNCTION' + numfunc;
        let type = 'iXyberBaseLib.SystemBase.RefObject';

        let newRefObj = await hmiclientbase
            .SettingsCreateObject(nameRef, type, eventObject?.id, 'New')
            .then((res: any) => {
                return res;
            });

        UpdateRefObject(newRefObj.id, rpath);
    };

    const UpdateRefObject = async (refId: string, rpath: string) => {
        await hmiclientbase.SettingsChangeProperty(refId, 'rpath', rpath);

        UpdateEventObject();
    };

    const DeleteRefObject = async (id: string) => {
        await hmiclientbase.SettingsDeleteObject(id);
        UpdateEventObject();
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }} /*onClick={() => closeCB && closeCB()}*/
        >
            <div
                style={{
                    padding: '1em',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'column'
                }}
                onClick={(e) => e.stopPropagation()}>
                <div style={{ overflow: 'auto' }}>
                    <div style={{}}>
                        {eventObject?.RefObjects?.map((RefObject: any, key: number) => (
                            <div
                                key={RefObject.id}
                                style={{
                                    display: 'flex',
                                    textAlign: 'center',
                                    justifyContent: 'left',
                                    alignItems: 'center'
                                }}>
                                <div>
                                    <Select
                                        value={RefObject.rpath}
                                        onChange={(event: any) => {
                                            UpdateRefObject(RefObject.id, event.target.value);
                                        }}>
                                        <option key={`${RefObject.id}-${key}`} value={RefObject.rpath}>
                                            {RefObject.rpath}
                                        </option>
                                        {pathsRef?.map((x, y) => <option key={x}>{x}</option>)}
                                    </Select>
                                </div>
                                <div>
                                    <CloseIcon onClick={() => DeleteRefObject(RefObject.id)} titel="Удалить" />
                                    {/* <button name={RefObject.id} onClick={(event: any) => { DeleteRefObject(event.target.name) }}>Удалить</button> */}
                                </div>
                            </div>
                        ))}

                        <div
                            style={{
                                display: 'flex',
                                textAlign: 'center',
                                justifyContent: 'left',
                                alignItems: 'center',
                                height: '2.4em'
                            }}>
                            <div>
                                <Select
                                    name={'newEvent'}
                                    onChange={(event: any) => {
                                        AddRefObject(event.target.value);
                                        event.target.value = '';
                                    }}>
                                    <option key={'newkey12'}> </option>
                                    {pathsRef?.map((x, y) => <option key={x}>{x}</option>)}
                                </Select>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '1em' }}>
                    <Button text="Закрыть" size="small" styleType="filled" onClick={() => closeCB && closeCB()} />
                </div>
            </div>
        </div>
    );
};
